import { DefaultPage } from 'components/templates/DefaultPage'
import { AuthProvider } from 'contexts/auth'
import { ComposeProvider } from 'contexts/compose'
import { ContractProvider } from 'contexts/contract'
import { InstitutionsProvider } from 'contexts/institutions'
import { AnimatePresence } from 'framer-motion'
import { Navigate, Route, Routes } from 'react-router-dom'
import Agent from './Agent'
import Biometria from './Auth/Biometria'
import Certificado from './Auth/Certificado'
import ChangePassword from './Auth/ChangePassword'
import Confirmation from './Auth/Confirmation'
import Forgot from './Auth/Forgot'
import Registration from './Auth/Registration'
import Reset from './Auth/Reset'
import SignIn from './Auth/SignIn'
import Contract from './Contract'
import Contracts from './Contracts'
import Disponibilidade from './Disponibilidade'
import Fee from './FeeManagement'
import { FinancialManagement } from './FinancialManagement'
import Institution from './Institution'
import Institutions from './Institutions'
import { NotFound, ValidationPage } from './NotFound'
import Notifications from './Notifications'
import PrivateRouting from './private-routes'
import Report from './Report'
import { ReportManagement } from './ReportManagement'
import { SearchContracts } from './SearchContracts'
import Users from './Users'
import { Vehicles } from './Vehicles'
import { ViewContractQrCode } from './ViewContractQrCode'


export const RoutesPages = () => {
    const e = (el: React.ReactNode) => <DefaultPage children={el} />
    return (
        <ComposeProvider
            with={[AuthProvider, InstitutionsProvider, ContractProvider]}
        >
            <AnimatePresence>
                <Routes>
                    <Route path="/instituicoes" element={<PrivateRouting />}>
                        <Route path="" element={e(<Institutions />)} />
                        <Route path=":id" element={e(<Institution />)} />
                    </Route>
                    <Route path="/usuarios" element={<PrivateRouting />}>
                        <Route path="" element={e(<Users />)} />
                        <Route path=":id" element={e(<Users />)} />
                    </Route>
                    <Route path="/disponibilidade" element={<Disponibilidade />} />
                    <Route
                        path="/agentes-financeiros"
                        element={<PrivateRouting />}
                    >
                        <Route path="" element={e(<Agent />)} />
                        <Route path=":id" element={e(<Agent />)} />
                    </Route>
                    <Route path="/contratos" element={<PrivateRouting />}>
                        <Route path="" element={e(<Contracts />)} />
                        <Route path=":id" element={e(<Contract />)} />
                    </Route>
                    <Route path="/consulta-contratos" element={<PrivateRouting />}>
                        <Route path="" element={e(<SearchContracts />)} />
                    </Route>
                    <Route path="/entrar" element={<SignIn />} />
                    <Route
                        path="/visualizar-contrato-qr-code"
                        element={<ViewContractQrCode />}
                    />
                    <Route path="/esqueci-senha" element={<Forgot />} />
                    <Route path="/certificado-digital" element={<Certificado />} />
                    <Route path="/biometria-facial" element={<Biometria />} />
                    <Route path="/veiculos" element={<PrivateRouting />}>
                        <Route path="" element={e(<Vehicles />)} />
                    </Route>
                    <Route path="/relatorio" element={<PrivateRouting />}>
                        <Route path="" element={e(<Report />)} />
                    </Route>
                    <Route path="/comunicacao" element={<PrivateRouting />}>
                        <Route path="" element={e(<Notifications />)} />
                    </Route>
                    <Route path="/gestao-taxas" element={<PrivateRouting />}>
                        <Route path="" element={e(<Fee />)} />
                    </Route>
                    <Route path="/alterar-senha" element={<PrivateRouting />}>
                        <Route path="" element={e(<ChangePassword />)} />
                    </Route>
                    <Route
                        path="/relatorio-financeiro"
                        element={<PrivateRouting />}
                    >
                        <Route path="" element={e(<FinancialManagement />)} />
                    </Route>
                    <Route path="/recuperar-senha" element={<Reset />} />
                    <Route path="/cadastro/:id" element={<Registration />} />
                    <Route path="/confirmacao/:id" element={<Confirmation />} />
                    <Route path="" element={<Navigate to="/entrar" />} />
                    <Route path="*" element={<NotFound />} />
                    <Route
                        path="/declaracao/53d570dd-7a3b-46a8-ad7d-fbb26ab835bb"
                        element={<ValidationPage />}
                    />
                    <Route
                        path="/relatorio-gestao"
                        element={<PrivateRouting />}
                    >
                        <Route path="" element={e(<ReportManagement />)} />
                    </Route>
                </Routes>
            </AnimatePresence>
        </ComposeProvider>
    )
}
